module.exports = __webpack_public_path__ + "assets/img/news_banner.0554dae4.jpg";